/*
 * Title:     	formHelper.js
 * Description: Form helpers
 * Author:      Mark Croxton, mcroxton@hallmark-design.co.uk
 * Copyright:   Hallmark Design
 * Updated:     July 13 2020
*/

// Submit form on select menu change
let form = document.querySelector('form[data-filter-form]');

if (form) {

    let formSelects = form.querySelectorAll('select[data-filter]');

    // reset selects when a search input is submitted
    form.addEventListener("submit", function(e) {
        let resetFields = form.querySelectorAll('[data-filter-reset]');
        let resetFieldHasValue = false;
        for (let i=0; i < resetFields.length; i++) {
            if (resetFields[i].value !== '') {
                resetFieldHasValue = true;
            }
        }
        if (resetFieldHasValue) {
            for (let i=0; i < formSelects.length; i++) {
                formSelects[i].value = '';
            }
        }
    });

    for (let i=0; i < formSelects.length; i++) {

        // update labels for this select
        let formSelectId = formSelects[i].getAttribute('id');
        if (formSelectId) {
            let label = document.querySelector('label[data-filter-label][for="'+formSelectId+'"]');
            if (label) {
                if (formSelects[i].value !== "") {
                    let selectedOption = formSelects[i].querySelector('option:checked');
                    //console.log(selectedOption);
                    if (selectedOption) {
                        label.setAttribute('data-selected', selectedOption.textContent);
                    }
                } else {
                    label.setAttribute('data-selected', label.textContent);
                }
            }
        }

        formSelects[i].addEventListener("change", function(e) {
            if (formSelects[i].dataset.redirect) {
                e.preventDefault();
                let redirectTo = formSelects[i].options[formSelects[i].selectedIndex].dataset.redirectTo;
                if (typeof redirectTo === 'undefined') {
                    redirectTo= formSelects[i].value;
                }
                if (redirectTo === '') {
                    redirectTo = formSelects[i].dataset.redirectDefault;
                    if (typeof redirectTo === 'undefined') {
                        redirectTo = form.getAttribute('action');
                    }
                }
                location.href = redirectTo;
            } else {
                // reset fields that are marked [data-filter-reset], except for the changed select
                let resetFields = form.querySelectorAll('[data-filter-reset]');
                for (let j=0; j < resetFields.length; j++) {
                    if (resetFields[j] !== formSelects[i]) {
                        resetFields[j].value = '';
                    }
                }
                form.submit();
            }
        });

    }
}